import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getKeysOfObject' })
export class GetKeysOfObjectPipe implements PipeTransform {
  transform(object): Array<string> {
    if (typeof object === 'object') {
      return Object.keys(object);
    }
  }
}
